import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import '@fontsource/roboto/400.css';

let theme = createTheme({
  palette: {
    primary: {
      main: '#723989',
    },
    secondary: {
      main: '#ee9338'
    }
  },
  typography: {
    fontFamily: 'Roboto' 
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Roboto',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#723989'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#ee9338'
        }
      }
    }
  }
})

theme = responsiveFontSizes(theme);

export { theme }